import { BaseModel } from "./BaseModel";

export class FieldModel extends BaseModel {
  RouteName = "Field";
  protected AuthState: boolean = true;
}
